import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLocationLink } from 'redux/location-links/actions';

import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';
import ProLabel from 'components/common/ProLabel';

import './LocationLinkColorSelectors.css';


function LocationLinkColorSelectors(props) {
  const { me, linkItem, patchLocationLink } = props;
  const { t } = useTranslation();
  const [currentButtonColor, setCurrentButtonColor] = useState(linkItem.button_color);
  const [currentFontColor, setCurrentFontColor] = useState(linkItem.font_color);

  const locked = me && me.subscription && !me.subscription.ff_maps;
  const placeholderContent = (
    <div>{t("This option is available on the PRO plan.")}</div>
  );

  const onButtonColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    setCurrentButtonColor(rgba);
    const form = new FormData();
    form.append('button_color', rgba);
    patchLocationLink(linkItem.id, form);
  };

  const onFontColorChange = color => {
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    setCurrentFontColor(rgba);
    const form = new FormData();
    form.append('font_color', rgba);
    patchLocationLink(linkItem.id, form);
  };

  return (
    <div className="location-link-color-selectors__component">
      <div className="picker-wrapper">
        <div className="label">
          <div className="text">{t("Marker Button Color")}</div>
          <ProLabel />
        </div>
        <div className="info-text">
          {t("Choose the colour visitors will see for the location buttons on your page")}
        </div>
        <ProFeaturePlaceholder
          noKeyIcon
          locked={locked}
          placeholderContent={placeholderContent}
        >
          <ColorPicker
            small
            key={`location-link-button-color-picker-key-${linkItem.id}`}
            pickerId={`location-link-button-color-picker-id-${linkItem.id}`}
            color={currentButtonColor}
            onChangeComplete={onButtonColorChange}
          />
        </ProFeaturePlaceholder>
      </div>

      <div className="picker-wrapper">
        <div className="label">
          <div className="text">{t("Marker Font Color")}</div>
          <ProLabel />
        </div>
        <div className="info-text">
          {t("You can change the font of the location button here")}
        </div>
        <ProFeaturePlaceholder
          noKeyIcon
          locked={locked}
          placeholderContent={placeholderContent}
        >
          <ColorPicker
            small
            key={`location-link-font-color-picker-key-${linkItem.id}`}
            pickerId={`location-link-font-color-picker-id-${linkItem.id}`}
            color={currentFontColor}
            onChangeComplete={onFontColorChange}
          />
        </ProFeaturePlaceholder>
      </div>
    </div>
  );
}

LocationLinkColorSelectors.propTypes = {
  patchLocationLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  me: PropTypes.object,
};

LocationLinkColorSelectors.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLocationLink,
  },
)(LocationLinkColorSelectors);
